import Dropdown from '@components/ProductComparison/_Dropdown';
import Product from '@models/product';

interface Props {
  selectedSkus: (string | '')[];
  products: Product[];
  updateSelectedProducts: (sku: string, index: number) => void;
  asContentRow?: boolean;
  className?: string;
}

const DropdownWrapper = ({
  asContentRow,
  selectedSkus,
  products,
  updateSelectedProducts,
}: Props) => {
  return (
    <div className="md:tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-bg-white tw-px-6 tw-pt-4 tw-gap-6 tw-pb-2 tw-w-full tw-z-50 tw-sticky tw-top-0">
      <div className="tw-hidden md:tw-block" />
      {selectedSkus.map((sku, i) => {
        return (
          <div className="tw-flex tw-flex-col tw-text-center tw-h-full" key={sku}>
            {!asContentRow && (
              <Dropdown
                sku={sku}
                products={products}
                updateSelectedProducts={updateSelectedProducts}
                index={i}
                selectedSkus={selectedSkus}
                className="tw-hidden md:tw-block"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DropdownWrapper;
